// src/pages/OptionStrategyDashboard.tsx
import React, { useState } from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import OptionStrategyFinder from '@/components/OptionStrategyFinder';
import OptionChain from '@/components/OptionChain';

const OptionStrategyDashboardPage: React.FC = () => {
  const [ticker, setTicker] = useState('');
  const [selectedExpiry, setSelectedExpiry] = useState<string | undefined>(undefined);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-purple-50">
      <NavBar />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto py-16 px-8 text-center">
          <div className="p-10 bg-white bg-opacity-90 rounded-3xl shadow-2xl backdrop-blur-md">
            <OptionStrategyFinder initialTicker={ticker} onTickerChange={setTicker} />
            {ticker && (
              <div className="mt-8">
                <OptionChain
                  symbol={ticker}
                  selectedExpiry={selectedExpiry}
                  onExpiryChange={setSelectedExpiry}
                />
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default OptionStrategyDashboardPage;
